import { axiosInstanceV1, getReqConfig } from './axiosInstance';
import { parseResponse } from './helper';
import LocalesEnum from '../enums/locales.enum';

const BASE = '/Promo';

export async function getPromos_req(cookies = {}, lang = LocalesEnum.DEFAULT) {
  return parseResponse(
    axiosInstanceV1.get(`/${lang}/Promos`, getReqConfig(cookies))
  );
}

export async function getPromo_req(
  cookies = {},
  key,
  lang = LocalesEnum.DEFAULT
) {
  return parseResponse(
    axiosInstanceV1.get(`${lang}${BASE}?key=${key}`, getReqConfig(cookies))
  );
}
